(function () {
  var THRESHOLD = 35000;

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  // ── Pasek darmowej wysyłki ──────────────────────────────────────────────
  function updateShippingBar(cart) {
    var total = cart.total_price;
    var textEl = document.querySelector('.ms-shipping-bar__text');
    var fillEl = document.querySelector('.ms-shipping-bar__fill');
    if (!textEl || !fillEl) return;
    if (total >= THRESHOLD) {
      textEl.textContent = 'Odblokowano darmową dostawę!';
      fillEl.style.width = '100%';
    } else {
      var remaining = ((THRESHOLD - total) / 100).toFixed(0);
      textEl.textContent = 'Do darmowej dostawy brakuje Ci ' + remaining + ' zł';
      fillEl.style.width = Math.min((total / THRESHOLD) * 100, 100) + '%';
    }
  }

  // ── Przycisk "Realizuj zakup" z ceną ───────────────────────────────────
  function updateCheckoutPrice(cart) {
    var priceEl = document.getElementById('ms-checkout-price');
    if (!priceEl) return;
    if (cart.total_discount > 0) {
      priceEl.innerHTML = '<s>' + fmt(cart.original_total_price) + '</s>\u00a0' + fmt(cart.total_price);
    } else {
      priceEl.textContent = fmt(cart.total_price);
    }
  }

  // ── Ceny per produkt (przekreślenie + nowa cena) ────────────────────────
  function updateProductPrices(cart) {
    var rows = document.querySelectorAll('.cart-items__table-row[data-key]');

    // Brak rabatu -> przywróć oryginalny HTML i usuń badge
    if (cart.total_discount === 0) {
      rows.forEach(function (row) {
        if (row.dataset.msOriginalHtml) {
          var priceDiv = row.querySelector('.cart-items__details > div:not(.cart-items__quantity)');
          if (priceDiv) priceDiv.innerHTML = row.dataset.msOriginalHtml;
          delete row.dataset.msOriginalHtml;
        }
        var badge = row.querySelector('.ms-discount-applied');
        if (badge) badge.remove();
        delete row.dataset.msApplied;
      });
      return;
    }

    rows.forEach(function (row) {
      var key = row.dataset.key;
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item || !item.total_discount) return;

      var priceDiv = row.querySelector('.cart-items__details > div:not(.cart-items__quantity)');
      if (!priceDiv) return;

      // Backup oryginału - jeśli już mamy, przywróć go przed kolejną modyfikacją (idempotentność)
      if (row.dataset.msOriginalHtml) {
        priceDiv.innerHTML = row.dataset.msOriginalHtml;
      } else {
        row.dataset.msOriginalHtml = priceDiv.innerHTML;
      }

      // Usuń stary badge jeśli jest
      var oldBadge = row.querySelector('.ms-discount-applied');
      if (oldBadge) oldBadge.remove();

      var discPerUnit = Math.round(item.line_price / item.quantity);
      var fmtLocal = function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; };

      // Sprawdź czy produkt jest promocyjny (ma compare-at-price w DOM)
      var compareAt = priceDiv.querySelector('s.compare-at-price');

      if (compareAt) {
        // Produkt promocyjny: ukryj spany z ceną sklepową, zostaw przekreślone compare_at
        var spans = priceDiv.querySelectorAll('span');
        spans.forEach(function (span) {
          if (!span.classList.contains('visually-hidden') && span.textContent.indexOf('zł') !== -1) {
            span.style.display = 'none';
          }
        });
      } else {
        // Produkt nieprzeceniony: przekreśl cenę sklepową
        var spans2 = priceDiv.querySelectorAll('span');
        spans2.forEach(function (span) {
          if (!span.classList.contains('visually-hidden') && span.textContent.indexOf('zł') !== -1) {
            span.classList.add('ms-price-strikethrough');
          }
        });
      }

      // Dodaj nową cenę po kodzie
      var discountedSpan = document.createElement('span');
      discountedSpan.className = 'ms-price-discounted';
      discountedSpan.textContent = fmtLocal(discPerUnit);
      priceDiv.appendChild(discountedSpan);

      // Badge
      var badge = document.createElement('p');
      badge.className = 'ms-discount-applied';
      badge.textContent = 'Kod rabatowy zastosowany';
      priceDiv.insertAdjacentElement('afterend', badge);

      row.dataset.msApplied = '1';
    });
  }

  // ── Główna funkcja aktualizacji ─────────────────────────────────────────
  function updateCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateShippingBar(cart);
        updateCheckoutPrice(cart);
        updateProductPrices(cart);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', updateCart);
  document.addEventListener('cart:refresh', updateCart);
  document.addEventListener('cart:updated', updateCart);
  document.addEventListener('cart-update', updateCart);

  // Rabat zastosowany / usunięty - czekamy 400ms na morphSection + sectionRenderer
  document.addEventListener('discount:update', function () {
    setTimeout(updateCart, 400);
  });

  // Zmiana ilości / usunięcie produktu - intercept fetch
  var origFetch = window.fetch;
  window.fetch = function (url, ...args) {
    return origFetch.call(this, url, ...args).then(function (res) {
      var u = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      if ((u.includes('/cart/change') || u.includes('/cart/update')) && res.ok) {
        setTimeout(updateCart, 400);
      }
      return res;
    });
  };

  // MutationObserver - łapie re-render cart drawer po morphSection
  var observerTarget = null;
  function setupObserver() {
    var target = document.querySelector('.cart-drawer__items');
    if (!target || observerTarget === target) return;
    observerTarget = target;
    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (cart.total_discount > 0) {
            var anyBadge = document.querySelector('.ms-discount-applied');
            var rows = document.querySelectorAll('.cart-items__table-row[data-key]');
            if (!anyBadge && rows.length > 0) {
              updateProductPrices(cart);
              updateCheckoutPrice(cart);
              updateShippingBar(cart);
            }
          }
        });
      }, 200);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  setupObserver();
  setInterval(setupObserver, 500);
})();
